import React,{useState} from 'react'
import "./Navigation.css"
import { Outlet,Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useAuth from '../../hooks/useAuth'

  


const Navigation = () => {

  const{count,setCount}=useAuth()

  const location = useLocation();

  //destructuring pathname from location
  const { pathname } = location;

  //Javascript split method to get the name of the path in array
  const splitLocation = pathname.split("/");
  

    const [isActive, setActive] = useState("true");
    let menu = document.querySelector('#menu-bars');
let navbar = document.querySelector('.navbars');


function menu_btn(){
  // menu.classList.toggle('fa-times');
  // navbar.classList.toggle('active');
setActive(!isActive);
}

let section = document.querySelectorAll('section');
let navLinks = document.querySelectorAll('header .navbars a');

window.onscroll = () =>{

  menu.classList.remove('fa-times');
  navbar.classList.remove('active');

  section.forEach(sec =>{

    let top = window.scrollY;
    let height = sec.offsetHeight;
    let offset = sec.offsetTop - 150;
    let id = sec.getAttribute('id');

    if(top >= offset && top < offset + height){
      navLinks.forEach(links =>{
        links.classList.remove('active');
        document.querySelector('header .navbars a[href*='+id+']').classList.add('active');
      });
    };

  });

}

function search_btn(){
  document.querySelector('#search-form').classList.toggle('active');
}

function close_btn(){
  document.querySelector('#search-form').classList.remove('active');
}

  return (
    <>
    
<header className="Header sticky-top navbar" >

<a href="#" class="logo"><i class="fa-sharp fa-solid fa-bags-shopping"></i>Bonika.</a>

<nav  className={`navbars ${isActive ? "active" : null} `} >
    <Link className={splitLocation[1] === "" ? "active" : ""} to="/">home</Link>
    <Link to="/dishes" className={splitLocation[1] === "dishes" ? "active" : ""}>dishes</Link>
    <Link to="/about" className={splitLocation[1] === "about" ? "active" : ""}>about</Link>
    <Link to="/menu" className={splitLocation[1] === "menu" ? "active" : ""} >menu</Link>
    <Link to="/review" className={splitLocation[1] === "rewiew" ? "active" : ""}>review</Link>
    <Link to="/order" className={splitLocation[1] === "order" ? "active" : ""}>order</Link>
</nav>

<div class="icons">
    <i className={`${splitLocation[1] === "" ? "active" : ""} fas fa-bars`} onClick={()=>{menu_btn()}} id="menu-bars"></i>
    <i  className={`${splitLocation[1] === "" ? "active" : ""} fas fa-search`} onClick={()=>{search_btn()}} id="search-icon"></i>
    <Link to="/login" className={`${splitLocation[1] === "login" ? "active" : ""} fas fa-person`}></Link>
    <Link  to="/cart" className={`${splitLocation[1] === "cart" ? "active" : ""} fas   fa-shopping-cart position-relative`} >
    <span class="position-absolute top-0 start-110 badge rounded-circle bg-danger">
    {count.length}
    <span class="visually-hidden">unread messages</span>
  </span>
    </Link>
</div>

</header>
<form action="" id="search-form">
    <input type="search" placeholder="search here..." name="" id="search-box"/>
    <label for="search-box" class="fas fa-search"></label>
    <i class="fas fa-times" onClick={()=>{close_btn()}} id="close"></i>
</form>
<Outlet/>
    </>
  )
}

export default Navigation